export const SET_ALUMNI = "SET_ALUMNI";
export const GET_ALUMNI = "GET_ALUMNI";
export const DELETE_ALUMNI = "DELETE_ALUMNI";
export const UPDATE_ALUMNI = "UPDATE_ALUMNI";
